(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-testimonial-press"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var slides = carousel.querySelector('[data-slides]');
    var slideEls = carousel.querySelectorAll('[data-slide]');
    var dots = carousel.querySelectorAll('[data-dot]');
    var prevBtn = carousel.querySelector('[data-prev]');
    var nextBtn = carousel.querySelector('[data-next]');
    var total = slideEls.length;
    var current = 0;
    var autoplayEnabled = carousel.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed, 10) || 4000;
    var timer = null;
    var startX = 0;
    var isDragging = false;

    if (total <= 1) return;

    function goTo(idx) {
      // Pause current video
      var currentSlide = slideEls[current];
      var currentVideo = currentSlide.querySelector('[data-video-el]');
      if (currentVideo) {
        currentVideo.pause();
        var btn = currentSlide.querySelector('[data-play-btn]');
        var playIcon = currentSlide.querySelector('[data-play-icon]');
        var pauseIcon = currentSlide.querySelector('[data-pause-icon]');
        if (btn) btn.classList.remove('is-playing');
        if (playIcon) playIcon.style.display = '';
        if (pauseIcon) pauseIcon.style.display = 'none';
      }

      current = (idx + total) % total;
      slides.style.transform = 'translateX(-' + (current * 100) + '%)';

      dots.forEach(function (d) { d.classList.toggle('is-active', parseInt(d.dataset.dot) === current); });

      if (autoplayEnabled) resetTimer();
    }

    function resetTimer() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, autoplaySpeed);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.dataset.dot)); });
    });

    // Play/Pause buttons
    carousel.querySelectorAll('[data-play-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var slide = btn.closest('[data-slide]');
        var video = slide.querySelector('[data-video-el]');
        var playIcon = btn.querySelector('[data-play-icon]');
        var pauseIcon = btn.querySelector('[data-pause-icon]');
        if (!video) return;
        if (video.paused) {
          video.play();
          btn.classList.add('is-playing');
          if (playIcon) playIcon.style.display = 'none';
          if (pauseIcon) pauseIcon.style.display = '';
          if (autoplayEnabled) clearInterval(timer);
        } else {
          video.pause();
          btn.classList.remove('is-playing');
          if (playIcon) playIcon.style.display = '';
          if (pauseIcon) pauseIcon.style.display = 'none';
          if (autoplayEnabled) resetTimer();
        }
      });
    });

    // Swipe support
    slides.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; isDragging = true; }, { passive: true });
    slides.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { goTo(current + (dx < 0 ? 1 : -1)); }
      isDragging = false;
    });
    slides.addEventListener('mousedown', function (e) { startX = e.clientX; isDragging = true; });
    slides.addEventListener('mouseup', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 60) { goTo(current + (dx < 0 ? 1 : -1)); }
      isDragging = false;
    });

    if (autoplayEnabled) resetTimer();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
